import React, { useEffect } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { SocialProofSection } from './components/SocialProofSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { VaultsSection } from './components/VaultsSection';
import { UrgencySection } from './components/UrgencySection';
import { OfferSection } from './components/OfferSection';
import { UpsellSection } from './components/UpsellSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { PainUrgencySection } from './components/PainUrgencySection';
import { FinalCTASection } from './components/FinalCTASection';
import { FooterSection } from './components/FooterSection';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { TopUrgencyBar } from './components/TopUrgencyBar';
import { BuyerPopup } from './components/BuyerPopup';
import { ClientTestimonialsSection } from './components/ClientTestimonialsSection';
import { useReveal } from './hooks/useReveal';
export function App() {
  useReveal();
  useEffect(() => {
    document.title = 'La Bóveda del Carpintero™ — Tu próximo proyecto ya está adentro';
    document.documentElement.lang = 'es-AR';
    const meta = document.createElement('meta');
    meta.name = 'facebook-domain-verification';
    meta.content = 'ukxbt6i9cor3c23xr4j0lek38bvd3m';
    document.head.appendChild(meta);
    const preconnects = ['https://fonts.googleapis.com', 'https://fonts.gstatic.com', 'https://cdn.magicpatterns.com'];
    const links: HTMLLinkElement[] = [];
    preconnects.forEach(href => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = href;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
      links.push(link);
    });
    return () => {
      document.head.removeChild(meta);
      links.forEach(link => document.head.removeChild(link));
    };
  }, []);
  return <div className="w-full min-h-screen bg-[#111111] pt-[60px] sm:pt-[64px]" data-id="element-0" data-mp="d4nwdiwxho3g">
      <TopUrgencyBar data-id="element-1" data-mp="d2l8p5j9071w" />
      {/* 1. MARCA */}
      <Header data-id="element-2" data-mp="85bbv4tj4t41" />
      <main data-id="element-3" data-mp="86mgf6usu4w7">
        {/* 2-5. PROMESA · MOCKUP · SUBTÍTULO · CTA 1 */}
        <HeroSection data-id="element-4" data-mp="3gkv17sr2xrdt" />
        {/* 6. PRUEBA SOCIAL */}
        <SocialProofSection data-id="element-5" data-mp="3glnz048296jt" />
        {/* 7. PROBLEMAS Y DOLORES */}
        <PainSection data-id="element-6" data-mp="3bncp5thrmw1l" />
        {/* 8. SOLUCIÓN */}
        <SolutionSection data-id="element-7" data-mp="3bkgtycxaylgu" />
        {/* 9. BONOS — LAS 8 BÓVEDAS ESPECIALES */}
        <VaultsSection data-id="element-8" data-mp="3qcipxlw94ubl" />
        {/* TESTIMONIOS DE CLIENTES */}
        <ClientTestimonialsSection data-id="element-9" data-mp="3ljg1fs6c0b29" />
        {/* 10. URGENCIA Y ESCASEZ */}
        <UrgencySection data-id="element-10" data-mp="2xudaftpt55v3" />
        {/* 11. OFERTA — CTA 2 */}
        <OfferSection data-id="element-11" data-mp="2xsseq0rrbgvn" />
        {/* 12. UPSELL (desactivado) */}
        <UpsellSection data-id="element-12" data-mp="2sv0pjeihy8v5" />
        {/* 13. TESTIMONIOS (preparado, sin datos inventados) */}
        <TestimonialsSection data-id="element-13" data-mp="18cq6dlx04itg" />
        {/* 14. GARANTÍA */}
        <GuaranteeSection data-id="element-14" data-mp="1d4hmf2ij765c" />
        {/* 15. PREGUNTAS FRECUENTES */}
        <FAQSection data-id="element-15" data-mp="1d5sql3fw2fwz" />
        {/* 16. DOLOR Y URGENCIA + CIERRE EMOCIONAL */}
        <PainUrgencySection data-id="element-16" data-mp="ygwkvd1b1ezj" />
        {/* 17. CTA 3 */}
        <FinalCTASection data-id="element-17" data-mp="13eof4dpf9d6w" />
      </main>
      {/* 18. PIE DE PÁGINA */}
      <FooterSection data-id="element-18" data-mp="13clobrgg3g14" />
      <StickyMobileCTA data-id="element-19" data-mp="1r497tobdnotd" />
      <BuyerPopup data-id="element-20" data-mp="1r3zh1yiiddmm" />
    </div>;
}